import React from 'react';
import { Mutation } from '@apollo/client/react/components';
import { Button } from '@material-ui/core';
import { DEACTIVATE_WRITER, GET_WRITERS, ACTIVE_WRITER } from '../../../queries/writer';

const ChangeStatus = (props) => {
  const { id, status } = props;

  if (status === 1) {
    return (
      <Mutation
        mutation={DEACTIVATE_WRITER}
        update={(store) => {
          const { userListWriters } = store.readQuery({ query: GET_WRITERS });
          store.writeQuery({
            query: GET_WRITERS,
            data: { userListWriters },
          });
        }}
      >
        {deactiveUser => (
          <div>
            <Button
              style={{ backgroundColor: 'red', color: 'white', padding: 5, height: 30, minWidth: 100 }}
              onClick={
              e => {
                e.preventDefault();
                deactiveUser({ variables: { id } });
              }
            }
              type="button"
            >
              Deactivate
            </Button>
          </div>
        )}
      </Mutation>
    );
  }
  if (status === 2) {
    return (
      <Mutation
        mutation={ACTIVE_WRITER}
        update={(store) => {
          const { userListWriters } = store.readQuery({ query: GET_WRITERS });
          store.writeQuery({
            query: GET_WRITERS,
            data: { userListWriters },
          });
        }}
      >
        {activeUser => (
          <div>
            <Button
              style={{ backgroundColor: 'green', color: 'white', padding: 5, height: 30, minWidth: 100 }}
              onClick={
            e => {
              e.preventDefault();
              activeUser({ variables: { id } });
            }
          }
              type="button"
            >
              Activate
            </Button>
          </div>
        )}
      </Mutation>
    );
  }

  return <></>;
};
export default ChangeStatus;
